import { get } from 'lodash';
import * as asyncActionCreator from '../../redux/actionCreators/async';
import * as syncActionCreator from '../../redux/actionCreators/sync';

import { getPins, updatePins } from '../../redux/actionCreators/async/employees';

export default function OnEnterLoadPins(store) {
  return (nextState, replace, done) => {
    const state = store.getState();

    store.dispatch(getPins((err, pins) => {
      if (!err) {
        store.dispatch(syncActions.loadPins(pins))}
      }
    ));

    done();

  };
}



// WEBPACK FOOTER //
// ./shared/react/OnEnterHooks/loadPins.js